const WIZARD_CODES = {
  ONBOARDING: 'onboarding',
  SELF_SCHEDULING: 'self_scheduling'
};

export default WIZARD_CODES;
